import React from "react";
import SignInFormContainer from 'data/redux/containers/signInFormContainer/SignInFormContainer';
import AuthenticationCard from '../authenticationCard';

export interface IInfoCardSquare {
  toggleLogin: () => void;
}

const Login = (props: IInfoCardSquare) => (
  <AuthenticationCard
    title="היכנסו לחשבונכם"
    switchCardComponent={<span style={{color: "#585858"}}>
        אין לכם משתמש?
        <span onClick={() => props.toggleLogin()} style={{cursor: "pointer", color: "#F28F17"}}> מלאו פרטים </span>
        </span>}
    authenticateComponent={<SignInFormContainer/>}
  />
);

Login.defaultProps = {
  toggleLogin: () => {
    
  },
};

export default Login;
